/* eslint-disable @typescript-eslint/no-explicit-any */
import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { GetEmpresasGestionadasAsesoriaByFiltersDtoProps } from "api/DTOs/GetEmpresasGestionadasAsesoriaByFiltersDto"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { EmpresaGestionadaEstado } from "../components/EmpresaGestionadaEstado"

export const EMPRESAS_GESTIONADAS_COLUMNS = (
  t: TFunction,
  setOpenDeleteModal: Dispatch<
    SetStateAction<{
      show: boolean
      company: GetEmpresasGestionadasAsesoriaByFiltersDtoProps | undefined
    }>
  >
) => {
  const columns = [
    {
      key: "razonSocial",
      header: `${t("empresasGestionadas.table.companyName")}`,
      field: "razonSocial",
      style: { width: "40%" },
    },
    {
      key: "nif",
      header: `${t("empresasGestionadas.table.nif")}`,
      field: "nif",
      style: { width: "4%" },
    },
    {
      key: "estadoInvitacion",
      header: `${t("empresasGestionadas.table.status")}`,
      field: "estadoInvitacion",
      alignCol: "center",
      body: ({
        id,
        estadoInvitacion,
      }: GetEmpresasGestionadasAsesoriaByFiltersDtoProps) =>
        EmpresaGestionadaEstado(estadoInvitacion, id),
    },
    {
      key: "provincia",
      header: `${t("empresasGestionadas.table.province")}`,
      field: "provincia",
    },
    {
      key: "actividad",
      header: `${t("empresasGestionadas.table.activity")}`,
      field: "actividad",
    },
    {
      key: "email",
      header: `${t("empresasGestionadas.table.email")}`,
      field: "email",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: GetEmpresasGestionadasAsesoriaByFiltersDtoProps) => {
        if (!rowData.id) return null

        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("empresasGestionadas.table.delete")}`,
                hasRedirect: true,
                action: () => {
                  setOpenDeleteModal({
                    show: true,
                    company: rowData,
                  })
                },
                icon: faTrashCan,
                className: "!tw-text-danger",
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
